import React from "react";
import { Helmet } from "react-helmet-async";
import PropTypes from "prop-types";

const PaginatedPageSeo = (props) => {
  const hasRestrictedFilters = () => {
    if (!props.hasFilters) return false;

    if (!props.location?.search) return false;
    const params = new URLSearchParams(props.location.search);
    const paramKeys = Array.from(params.keys());

    const nonPageParams = paramKeys.filter((param) => param !== "page");

    if (nonPageParams.length === 1 && nonPageParams[0] === "genre") {
      return false;
    }

    return props.hasFilters;
  };

  return (
    <Helmet>
      {hasRestrictedFilters() && (
        <meta name="robots" content="noindex, nofollow" />
      )}
      {!hasRestrictedFilters() && (
        <meta name="robots" content="index, follow" />
      )}
      {props.location && props.page < props.lastPage && (
        <link
          rel="next"
          href={
            props.location.pathname +
            (props.updatePageQuery(props.location.search, props.page + 1) ||
              "?page=" + (props.page + 1))
          }
        />
      )}
      {props.location && props.page > 1 && (
        <link
          rel="prev"
          href={
            props.location.pathname +
            (props.updatePageQuery(props.location.search, props.page - 1) ||
              "?page=" + (props.page - 1))
          }
        />
      )}
      {hasRestrictedFilters() ? (
        <link rel="canonical" href={props.location.pathname} />
      ) : (
        <link
          rel="canonical"
          href={
            props.location.pathname +
            (props.page > 1
              ? props.updatePageQuery(props.location.search, props.page) ||
                "?page=" + props.page
              : "")
          }
        />
      )}
      <title>{props.meta_title}</title>

      {props.description && (
        <meta name="description" content={props.description} />
      )}
      <meta name="og:title" content={props.meta_title} />
      {props.meta_description ? (
        <meta name="og:description" content={props.meta_description} />
      ) : (
        <meta
          name="og:description"
          content={props.categoryDefaultOgDescription}
        />
      )}
    </Helmet>
  );
};

PaginatedPageSeo.propTypes = {
  page: PropTypes.number.isRequired,
  lastPage: PropTypes.number.isRequired,
  location: PropTypes.object.isRequired,
  updatePageQuery: PropTypes.func.isRequired,
  meta_title: PropTypes.string,
  meta_description: PropTypes.string,
  hasFilters: PropTypes.bool,
};

export default PaginatedPageSeo;
